<template>
    <div class="container-section-video">
        <span>
            <div class="video">
                <video-vimeo v-if="drawer_true === false"></video-vimeo>
                 <modules v-if="drawer_true === true"></modules>
            </div>
            <div class="resource">
                <div class="other-resources">
                    <div class="label">
                        Recursos
                    </div>
                    <div >
                        <resources-section-video :resource="resource_all"></resources-section-video>
                    </div>
                </div>
                <div class="questions">
                    <div class="label">
                        Preguntas y respuestas
                    </div>
                    <div style="max-height: 600px;  overflow-y: scroll;">
                        <question-store></question-store>
                    </div>
                </div>
            </div>
        </span>

    </div>
</template>
<script>
    import {mapState, mapGetters} from 'vuex'
    import videoVimeo from './../../../resources/card_vimeo.vue'
    import ResourcesSectionVideo from './resources_section_video.vue'
    import Modules from './../../Modules_Courses/modules_in_course.vue'
    import QuestionStore from './../../questions/QuestionsMessage.vue'
    export default {
        name: 'sectionVideoStore',
        components: {
            videoVimeo,
            ResourcesSectionVideo,
            QuestionStore,
            Modules
        },
        created(){

        },
        data(){
            return {
            }
        },
        computed: {
            ...mapState,
            ...mapGetters({
                resource_all: 'course/resource_all',
                drawer_true: 'drawer_true',
                RESOURCE_NO_VIDEO: 'RESOURCE_NO_VIDEO',
                resource : 'course/MODULE_SELECTED'
            })
        },
        methods:{

        },
    }
</script>
<style scoped>
    .container-section-video{
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        padding-left: 90px;
        margin-right: 10px;

    }
    .video{
        display: flex;
        flex-direction: row;
        justify-content: center;
        width: 100%;
        height: 100%;
    }
    .resource{
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        flex-wrap: wrap;

        border-radius: 2px;
    }
    .other-resources{
        width: 45%;
        padding-right: 3px;
    }
    .questions{
        width: 55%;
        padding-left: 3px;
    }
    .label{
        width: 100%;
        height: 40px;
        text-align: center;
        font-size: 1.2rem;
        background-color: #7465E4;
        color: white;
        padding-top: 5px;
        font-weight: 600;

    }
    .label:hover{
        background-color: #968AEA;
    }

    @media screen and (max-width: 1024px) {
        .video{
            display: flex;
            flex-direction: row;
            justify-content: center;
            width: 100%;
            height: auto;
        }
        .resource{
            display: flex;
            flex-direction: column;
            border-radius: 2px;
            width: 100%;
        }
        .other-resources{
            width: 100%;
        }
        .questions{
            width: 100%;
        }
        .container-section-video{
            width: 100%;
            padding-left: 5px;
            margin-right: 0px;
        }
        .label{
            margin: 5px 0 5px 5px;
        }
    }
</style>